export default class ItemModel {
    constructor(
        id = "",
        UPC = "",
        Categorie = {Id: "", Label: "", SubCategorie: {Id: "", Label: ""}},
        //sousCategorie={Id:"", Label:""},
        ChildItems = [],
        CreateAt,
        Description = "",
        HasChilds = false,
        ImageUrl = "",
        InternalId = "",
        IsExpirationDateRequire = true,
        IsParent = [],
        IsProductValidated = false,
        Name = "",
        Price = 0,
        PriceUpdateAt,
        SearchKeys = [],
        Stock = {Cassablanca: 0, Dekon: 0},
        Threshold,
        Images,
        UpdateAt,
        ItemClsass,
        LastBuyPrice,
        NewPrice,
        RefEquivalence,
        ReceptionDate,
        LastBuyDate,
        LastUpdatedBy,
        Vendors,
        //SellPrice
    ) {
        this.id = id;
        this.UPC = UPC;
        this.Categorie = Categorie;
        //this.sousCategorie = sousCategorie;
        this.ChildItems = ChildItems;
        this.CreateAt = CreateAt;
        this.Description = Description;
        this.HasChilds = HasChilds;
        this.ImageUrl = ImageUrl;
        this.InternalId = InternalId;
        this.IsExpirationDateRequire = IsExpirationDateRequire;
        this.IsParent = IsParent;
        this.IsProductValidated = IsProductValidated;
        this.Name = Name;
        this.Price = Price;
        this.PriceUpdateAt = PriceUpdateAt;
        this.SearchKeys = SearchKeys;
        this.Stock = Stock;
        this.Threshold = Threshold;
        this.Images = Images;
        this.UpdateAt = UpdateAt;

        this.ItemClsass = ItemClsass;
        this.LastBuyPrice = LastBuyPrice;
        this.NewPrice = NewPrice;
        this.RefEquivalence = RefEquivalence;
        this.ReceptionDate = ReceptionDate;
        this.LastBuyDate = LastBuyDate;
        this.LastUpdatedBy = LastUpdatedBy;
        this.Vendors = Vendors;
        //this.SellPrice=SellPrice
    }

    static mapToItem(id = "", Itemtab) {

        return new ItemModel(
            this.id = id,
            this.UPC = Itemtab['UPC'],
            this.Categorie = Itemtab['Categorie'],
            //this.sousCategorie =  Itemtab['sousCategorie'],
            this.ChildItems = Itemtab['ChildItems'],
            this.CreateAt = Itemtab['CreateAt'],
            this.Description = Itemtab['Description'],
            this.HasChilds = Itemtab['HasChilds'],
            this.ImageUrl = Itemtab['ImageUrl'],
            this.InternalId = Itemtab['InternalId'],
            this.IsExpirationDateRequire = Itemtab['IsExpirationDateRequire'],
            this.IsParent = Itemtab['IsParent'],
            this.IsProductValidated = Itemtab['IsProductValidated'],
            this.Name = Itemtab['Name'],
            this.Price = Itemtab['Price'],
            this.PriceUpdateAt = Itemtab['PriceUpdateAt'],
            this.SearchKeys = Itemtab['SearchKeys'],
            this.Stock = Itemtab['Stock'],
            this.Threshold = Itemtab['Threshold'],
            this.Images = Itemtab['Images'],
            this.UpdateAt = Itemtab['UpdateAt'],

            this.ItemClsass = Itemtab['ItemClsass'],
            this.LastBuyPrice = Itemtab['LastBuyPrice'],
            this.NewPrice = Itemtab['NewPrice'],
            this.RefEquivalence = Itemtab['RefEquivalence'],
            this.ReceptionDate = Itemtab['ReceptionDate'],
            this.LastBuyDate = Itemtab['LastBuyDate'],
            this.LastUpdatedBy = Itemtab['LastUpdatedBy'],
            this.Vendors = Itemtab['Vendors'],
            //this.SellPrice=Itemtab['SellPrice']
        );
    }

}


